module.exports = __webpack_public_path__ + "img/ott.1254a886.png";